module.exports = __webpack_public_path__ + "img/blue_eye.5e072c50.svg";